import React from 'react';
import Switch from 'react-switch';

interface Props {
    option: boolean;
    onChange: () => void;
    offColor?: string;
}

const Toggle: React.FC<Props> = ({ option, onChange, offColor }) => (
    <Switch
        onChange={onChange}
        checked={option}
        uncheckedIcon={false}
        checkedIcon={false}
        onColor="#19B5FE"
        onHandleColor="#FFFFFF"
        offColor={offColor || '#E6E6E6'}
        handleDiameter={24}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        height={24}
        width={48}
    />
);

export default React.memo(Toggle);
